import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getListing } from '../services/listingService';
import OfferList from '../components/OfferList';
import Chat from '../components/Chat';
import VerificationBadge from '../components/VerificationBadge';
import '../styles/ListingDetail.css';

const ListingDetail = () => {
    const { id } = useParams();
    const { user } = useAuth();
    const [listing, setListing] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadListing();
    }, [id]);

    const loadListing = async () => {
        try {
            setLoading(true);
            const data = await getListing(id);
            setListing(data);
            setError(null);
        } catch (err) {
            setError('Failed to load listing');
            console.error('Error loading listing:', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="loading">Loading listing...</div>;
    if (error) return <div className="error">{error}</div>;
    if (!listing) return <div className="not-found">Listing not found</div>;

    const isOwner = user && listing.user_id === user.id;

    return (
        <div className="listing-detail">
            <div className="listing-header">
                <h1>{listing.title}</h1>
                <p className="price">${listing.price}</p>
            </div>

            <div className="listing-content">
                <div className="listing-images">
                    {listing.images && listing.images.map((image, index) => (
                        <img 
                            key={index} 
                            src={image.image_path} 
                            alt={`${listing.title} - Image ${index + 1}`}
                        />
                    ))}
                </div>

                <div className="listing-info">
                    <p className="description">{listing.description}</p>
                    <div className="details">
                        <p><strong>Location:</strong> {listing.location}</p>
                        <p><strong>Delivery:</strong> {listing.delivery_available ? 'Available' : 'Not available'}</p>
                        <div className="seller-info">
                            <p><strong>Listed by:</strong> {listing.seller_name}</p>
                            {listing.user && listing.user.verification_status && (
                                <VerificationBadge 
                                    verificationStatus={listing.user.verification_status} 
                                    size="medium" 
                                />
                            )}
                        </div>
                        <p><strong>Listed on:</strong> {new Date(listing.created_at).toLocaleDateString()}</p>
                    </div>
                </div>
            </div>

            {isOwner && (
                <div className="seller-section">
                    <h2>Manage Offers</h2>
                    <OfferList listingId={id} />
                </div>
            )}

            {!isOwner && user && (
                <div className="buyer-section">
                    <h2>Make an Offer</h2>
                    {/* Offer form will be added in the next task */}
                </div>
            )}

            {/* Chat section - only available to non-owners */}
            {!isOwner && (
                <div className="chat-section">
                    <h2>Ask Questions</h2>
                    <Chat listingId={id} listingTitle={listing.title} />
                </div>
            )}
        </div>
    );
};

export default ListingDetail; 